import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Suspense } from 'preact/compat';
import { useTranslation } from 'react-i18next';
import { Await, Form, useLoaderData, useParams, useSearchParams, } from 'react-router';
import '@etchteam/diamond-ui/composition/FormGroup/FormGroup';
import '@etchteam/diamond-ui/composition/Enter/Enter';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@/components/composition/Wrap/Wrap';
import MaterialSearchInput from '@/components/control/MaterialSearchInput/MaterialSearchInput';
import PopularMaterials from '@/components/template/PopularMaterials/PopularMaterials';
import useFormValidation from '@/lib/useFormValidation';
export default function PlacesSearchPage() {
    const { t } = useTranslation();
    const { postcode } = useParams();
    const { popularMaterials: popularMaterialsPromise } = useLoaderData();
    const [searchParams] = useSearchParams();
    const autofocus = searchParams.get('autofocus') === 'true';
    const form = useFormValidation('search');
    function generatePopularMaterialPath(material) {
        const placesSearchParams = new URLSearchParams();
        placesSearchParams.set('materials', material.id);
        placesSearchParams.set('search', material.name);
        return `/${postcode}/places?${placesSearchParams.toString()}`;
    }
    return (_jsx("diamond-section", { padding: "lg", children: _jsxs("locator-wrap", { children: [_jsx("h3", { id: "places-search-label", children: t('places.search.label') }), _jsx("diamond-enter", { type: "fade", className: "layer-one", children: _jsx(Form, { method: "post", onSubmit: form.handleSubmit, children: _jsx("diamond-form-group", { children: _jsx(MaterialSearchInput, { inputLabelledBy: "places-search-label", autofocus: autofocus, handleBlur: form.handleBlur, handleInput: form.handleInput, submitting: form.submitting.value, valid: form.valid.value, includeFeedbackForm: true }) }) }) }), _jsx(Suspense, { fallback: null, children: _jsx(Await, { resolve: popularMaterialsPromise, children: (popularMaterials) => (_jsx(PopularMaterials, { materials: popularMaterials, generatePath: generatePopularMaterialPath })) }) })] }) }));
}
